// extracted by mini-css-extract-plugin
export default {"outer":"Search__outer___k57lc","search_box":"Search__search_box___l1qTx","autocomplete":"Search__autocomplete___Z2Njf"};